import { SearchResults } from "@omni/components/components/Search/SearchResults/searchResults";
import { ConditionalBreakPoint } from "@omni/components/utils/breakpoints/breakpoints.helpers";
import { SearchResultsProps } from "@omni/types/components/props/searchResults.props";
import { cn } from "@omni/utils/styles";

import { SortListItem } from "./components/sort/listItem.component";

const SearchResultsContainer = ({
    algoliaSearchParameters,
    productTileConfig,
    showFacets
}: SearchResultsProps) => {
    return (
        <SearchResults
            algoliaSearchParameters={algoliaSearchParameters}
            productTileConfig={productTileConfig}
            showFacets={showFacets}
        >
            <SearchResults.Skeleton>
                <SearchResults.Skeleton.SearchResults />
            </SearchResults.Skeleton>
            <SearchResults.Results>
                <SearchResults.Results.Title>
                    <SearchResults.Results.Title.Component />
                </SearchResults.Results.Title>
                <SearchResults.Results.NumberOfHits>
                    <SearchResults.Results.NumberOfHits.Component />
                </SearchResults.Results.NumberOfHits>
                <SearchResults.Results.Wrapper>
                    <SearchResults.Results.ProductResults>
                        <SearchResults.Results.ProductResults.Facets>
                            <ConditionalBreakPoint
                                condition={(breakpoints) => !breakpoints.lg}
                            >
                                <SearchResults.Results.ProductResults.ResultsView.Filters.Sticky>
                                    <div className={cn("tw:w-full")}>
                                        <SearchResults.Results.ProductResults.Facets.OpenFacetsButton
                                            className={cn(
                                                "tw:w-full!",
                                                "tw:lg:hidden"
                                            )}
                                        />
                                    </div>
                                    <div className={cn("tw:w-full")}>
                                        <SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort>
                                            <SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort.List
                                                className={cn("tw:w-full!")}
                                                renderOption={(props) => (
                                                    <SortListItem {...props} />
                                                )}
                                            />
                                        </SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort>
                                    </div>
                                </SearchResults.Results.ProductResults.ResultsView.Filters.Sticky>
                            </ConditionalBreakPoint>
                            <SearchResults.Results.ProductResults.Facets.Variants.Mobile>
                                <SearchResults.Results.ProductResults.ResultsView.Filters.AvailableInStore />
                                <SearchResults.Results.ProductResults.Facets.Product />
                            </SearchResults.Results.ProductResults.Facets.Variants.Mobile>
                            <SearchResults.Results.ProductResults.Facets.Variants.NonMobile>
                                <SearchResults.Results.ProductResults.Facets.Product />
                            </SearchResults.Results.ProductResults.Facets.Variants.NonMobile>
                        </SearchResults.Results.ProductResults.Facets>
                        <SearchResults.Results.ProductResults.ResultsView>
                            <SearchResults.Results.ProductResults.ResultsView.Header>
                                <SearchResults.Results.ProductResults.ResultsView.Header.Title />
                                <SearchResults.Results.ProductResults.ResultsView.Filters>
                                    <ConditionalBreakPoint
                                        condition={(breakpoints) =>
                                            !breakpoints.lg
                                        }
                                    >
                                        <div className={cn("tw:lg:hidden")}>
                                            <SearchResults.Results.ProductResults.Facets.OpenFacetsButton
                                                className={cn(
                                                    "tw:w-full!",
                                                    "tw:lg:hidden"
                                                )}
                                            />
                                        </div>
                                    </ConditionalBreakPoint>
                                    <div
                                        className={cn(
                                            "tw:hidden tw:items-center",
                                            "tw:not-first:ml-4 tw:not-first:pl-4 tw:not-first:border-l tw:not-first:border-divider",
                                            "tw:md:flex "
                                        )}
                                    >
                                        <SearchResults.Results.ProductResults.ResultsView.Filters.ProductHitsPerPage />
                                    </div>
                                    <div
                                        className={cn(
                                            "tw:not-first:ml-4 tw:not-first:pl-4 tw:not-first:border-l tw:not-first:border-divider"
                                        )}
                                    >
                                        <SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort>
                                            <SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort.List
                                                renderOption={(props) => (
                                                    <SortListItem {...props} />
                                                )}
                                            />
                                        </SearchResults.Results.ProductResults.ResultsView.Filters.ProductSort>
                                    </div>
                                    <ConditionalBreakPoint
                                        condition={(breakpoints) =>
                                            !!breakpoints.lg
                                        }
                                    >
                                        <div
                                            className={cn(
                                                "tw:flex tw:items-center tw:not-first:ml-4 tw:not-first:pl-4 tw:not-first:border-l tw:not-first:border-divider"
                                            )}
                                        >
                                            <SearchResults.Results.ProductResults.ResultsView.Filters.AvailableInStore
                                                className={cn("tw:pl-0!")}
                                            />
                                        </div>
                                    </ConditionalBreakPoint>
                                </SearchResults.Results.ProductResults.ResultsView.Filters>
                            </SearchResults.Results.ProductResults.ResultsView.Header>
                            <SearchResults.Results.ProductResults.ResultsView.SelectedFacets
                                className={cn("tw:mb-3")}
                                component={"PRODUCT_FACETS"}
                            />
                            <SearchResults.Results.ProductResults.ResultsView.ResultList
                                className={cn("tw:mb-3")}
                                hitComponent={({ hit }) => (
                                    <SearchResults.Results.ProductResults.ResultsView.ResultList.HitComponent
                                        hit={hit}
                                    />
                                )}
                            />
                            <SearchResults.Results.Footer>
                                <SearchResults.Results.Footer.GuaranteeNotice />
                                <SearchResults.Results.Footer.Pagination.Product
                                    className={cn("tw:mb-3")}
                                />
                            </SearchResults.Results.Footer>
                        </SearchResults.Results.ProductResults.ResultsView>
                    </SearchResults.Results.ProductResults>
                    <SearchResults.Results.ContentResults>
                        <SearchResults.Results.ContentResults.ResultsView>
                            <SearchResults.Results.ContentResults.ResultsView.Header />
                            <SearchResults.Results.ContentResults.ResultsView.ResultList
                                className={cn("tw:mb-3")}
                                hitComponent={({ hit }) => (
                                    <SearchResults.Results.ContentResults.ResultsView.ResultList.HitComponent
                                        hit={hit}
                                    />
                                )}
                            />
                            <SearchResults.Results.Footer>
                                <SearchResults.Results.Footer.Pagination.Content
                                    className={cn("tw:mb-3")}
                                />
                            </SearchResults.Results.Footer>
                        </SearchResults.Results.ContentResults.ResultsView>
                    </SearchResults.Results.ContentResults>
                </SearchResults.Results.Wrapper>
            </SearchResults.Results>
            <SearchResults.SaveScrollPosition />
            <SearchResults.InitSearch />
        </SearchResults>
    );
};

export { SearchResultsContainer };
